import React, { useEffect, useState } from 'react';
import { useLanguage } from '../../../context/language';
import Logo from '../../../assets/logo.png';
//import QrCode from '../../../assets/imgQR_code.jpeg';
import { getStrLang } from '../../Translate';
import 'jquery-ui-dist/jquery-ui';
import PixDefault from '../../pixComponentes/pixDefault';
import PixSplited from '../../pixComponentes/pixSplited';
import PixSlide from '../../pixComponentes/pixSlide';
import { getDeposit } from '../../../api/fastcoinService';
import { getURLBackToPanel } from '../../../context/brokersUrl';
import $ from 'jquery';
import Timer from '../../Timer';

const Pix = (props) => {
    //Chamada para as variáveis e funções do Context
    const { translate, lang } = useLanguage();
    const [telaPix, setTelaPix] = useState("default");
    const [expirado, setExpirado] = useState(false);

    //parametros para split do pix
    const [spt1, setSpt1] = useState("Pix");
    const [spt2, setSpt2] = useState("Pix");

    //Valores para pagamento
    const [vSpt1, setVspt1] = useState(0);
    const [vSpt2, setVspt2] = useState(0);
    const [waitingPayment, setWaitingPayment] = useState(sessionStorage.getItem("waiting_payment") !== null ? JSON.parse(sessionStorage.getItem("waiting_payment")) : false);


    //Traduz o texto na tela quando mudado o idioma pelo usuário
    useEffect(() => {
        translate();
    }, [translate]);

    function switchScreen(tela) {

        switch (tela) {
            case "splited":
                return (<PixSplited setWaitingPayment={setWaitingPayment} setShowTermos={props.setShowTermos} setTelaPix={setTelaPix} vSpt1={vSpt1} vSpt2={vSpt2} spt1={spt1} spt2={spt2} />)

            case "slide":
                return (<PixSlide setWaitingPayment={setWaitingPayment} setShowTermos={props.setShowTermos} setTelaPix={setTelaPix} vSpt1={vSpt1} vSpt2={vSpt2} setVspt1={setVspt1} setVspt2={setVspt2} spt1={spt1} setSpt1={setSpt1} spt2={spt2} setSpt2={setSpt2} />)

            default:
                return (<PixDefault setWaitingPayment={setWaitingPayment} setShowTermos={props.setShowTermos} setTelaPix={setTelaPix} />)

        }
    }

    useEffect(() => {
        function doEffect() {
            let ctrl = $("#message-pix span");
            $(ctrl).css("display", "flex");
            $(ctrl).fadeIn(500, function () {
                ctrl.effect("pulsate", 15000).fadeOut(500);
                doEffect(ctrl);
            });
        }
        function checkPayment() {
            setTimeout(function () {
                getDeposit(sessionStorage.getItem("order_no"))
                    .then(res => {
                        if (res.status.toLowerCase() === "paid") {
                            setWaitingPayment(false);
                            sessionStorage.setItem("waiting_payment", false);
                            window.location.replace(getURLBackToPanel());
                        } else {
                            checkPayment();
                        }
                    })
                    .catch(err => {
                        alert(err);
                        checkPayment();
                    })
            }, 30000);
        }
        if (waitingPayment) {
            doEffect();
            sessionStorage.setItem("waiting_payment", true);
            checkPayment();
        }
    }, [waitingPayment]);

    
    return (
        <div className="group-pix-content">
            <div className="infoarea-pix">
                {props.pix_time_limit==="true" && <Timer countdown={60} setExpirado={setExpirado} />}
                
                {!expirado && props.pix_time_limit==="true"?
                    <div id='message-pix' className='infoarea-pix-message'>
                        <span data-lang-str="waiting-payment-pix"></span>
                    </div>:<div id='message-pix' className='infoarea-pix-message'>
                        <span data-lang-str="waiting-payment-pix"></span>
                    </div>
                }
                <div className="form-pix-header">
                    {/*<img id="image-logo-tabs" src={Logo} alt={"Logo"} style={{width: "50%"}} /> */}
                </div>
            </div>
            <div className="pix-container">

                {props.pix_time_limit==="true"?
                    <>
                    {!expirado && switchScreen(telaPix)}
                    </>:<>
                        {switchScreen(telaPix)}
                    </>
                }
            </div>
            {expirado && props.pix_time_limit==="true"?
                <>
                    <p className="center footer_pix"><b>{getStrLang(lang.nameLang, "payment_expiration")}</b></p>
                </>
                :
                <>
                    <p className="center footer_pix"><b>{getStrLang(lang.nameLang, "msg5_PIX2")}</b></p>
                </>
            }
        </div>
    )
}

export default Pix;